<template>
    <validation-observer ref="observer" tag="div" class="observer"
                        v-slot="{passes, invalid}">

        <div class="grid grid-cols-6 gap-6 mt-8">
            <div class="col-span-6">
            <validation-provider ref="phone" name="phone" :rules="phoneValidationRules" v-slot="{ errors, touched }">

                <label for="phone" class="block text-sm font-medium text-gray-700">What is your phone number? <span class="quote-cf-phone-optional-text text-xs">(Optional)</span></label>
                <div class="mt-1 flex rounded-md shadow-sm w-full md:w-1/2">
                    <input v-model="form.phone.value" type="tel" name="phone" id="phone" autocomplete="phone" @focus="$emit('focus')"
                           class="focus:ring-blue-500 focus:border-blue-500 flex-1 block w-full px-3 py-2 rounded-md sm:text-sm "
                           :class="{
                        'border-2 border-red-300 placeholder-red-300':errors.length,
                        'border border-gray-300 ': !errors.length
                    }"
                    />
                </div>
                <p class="mt-2 text-sm text-gray-500 quote-cf-phone-extra-text hidden">We’ll send you your quote <b>via SMS</b></p>
              <p class="mt-2 text-sm text-red-600"
                 v-if="errors.length && (touched || form.phone?.value?.length >= 11 || form.phone?.value?.match(/[A-Za-z]/))">
                {{ errors[0] }}
              </p>
            </validation-provider>
            </div>
        </div>

    </validation-observer>

</template>

<script>

export default {
    name: "PhoneInput",
    props: {
        form: {
            type: Object,
            default: () => {},
        }
    },
    computed: {
        phoneValidationRules() {
            return {
                uk_number: {
                    min: 10,
                    max: 11
                },
                mobile_only_personal_cover: {
                    coverType: this.form?.cover_type?.value
                }
            };
        }
    },
    methods: {
        async validates(){
            return await this.$refs.observer.validate()
        }
    },
    async mounted() {

    }
}
</script>

<style scoped>

</style>
